<mat-form-field class="w-full max-w-[500px]">
  <span matPrefix class="prefix-bg-language-dropdown"><ui-icon icon="griddy-globe"></ui-icon></span>
  <mat-select
    [value]="selectedLanguage"
    (selectionChange)="onLanguageChange($event.value)"
    [disabled]="disabled"
    [attr.placeholder]="placeholder">
    @for (option of languages$ | async; track option.code) {
      <mat-option [value]="option.code">{{ option.native }} ({{ option.english }}) </mat-option>
    }
  </mat-select>
</mat-form-field>
